import { BACKEND_BASE_URL } from "../constants";
import { backendTransportRequest } from "./backendTransport";
import exceptionService from "./exceptionService";
export interface VerifyAddressInputType {
  address: { regionCode: "US"; addressLines: any };
}
export interface VerifyAddressResultType {
  formattedAddress: string;
  location: any;
  isBusiness: boolean;
  isResidential: boolean;
  isPOBox: boolean;
  completeAddress: boolean;
  addressConfirmed: boolean;
  confirmedComponents: any;
  unconfirmedComponents: any;
  placeId: any;
}
const googleAPIService = {
  async verifyAddress(address: VerifyAddressInputType): Promise<VerifyAddressResultType | null> {
    const r = await backendTransportRequest<VerifyAddressResultType>("/google/validate-address", {
      body: address,
    });
    if (r.error) {
      exceptionService.logError(r.error, "googleAPIService.verifyAddress");
      return null;
    }
    return r.data;
  },
  async getPlacePictures(placeId: string): Promise<any> {
    if (!placeId) return null;
    const r = await backendTransportRequest<string>(
      `/google/place-picture/${encodeURIComponent(placeId)}`,
      { method: "GET" }
    );
    return r.data ? `${BACKEND_BASE_URL}${r.data}` : null;
  },
  async getStreetViewPictureURL(latitude: number, longitude: number): Promise<any> {
    return `${BACKEND_BASE_URL}/google/street-view?latitude=${encodeURIComponent(
      latitude
    )}&longitude=${encodeURIComponent(longitude)}`;
  },
};
export default googleAPIService;
